import { mapState } from 'vuex'
import ScrollUtils from 'utils/scrollUtils'
import DataLayer from 'services/AirBaltic/DataLayer'
import cloneDeep from 'lodash/cloneDeep'
import Pimcore from 'services/AirBaltic/Pimcore'
import CookieUtils from 'utils/CookieUtils'
import * as Sentry from '@sentry/browser'

const CookieSelectMixin = {
  data() {
    return {
      showCheckboxes: false
    }
  },
  computed: {
    ...mapState({
      cookieTypes: (state) => state.main.tempCookies
    })
  },
  methods: {
    $_cookieSelectMixin_privacyLink(actionName, refComponent = 'description') {
      const privacyPolicyLink = this.$refs[refComponent]?.querySelectorAll('[data-privacy]')
      let that = this
      if (privacyPolicyLink?.length) {
        for (const policy of privacyPolicyLink) {
          policy.addEventListener('click', function () {
            that.$_cookieSelectMixin_sendData(actionName, 'Privacy policy link clicked')
          })
        }
      }
    },
    $_cookieSelectMixin_isChecked(name) {
      return this.cookieTypes.includes(name)
    },
    $_cookieSelectMixin_toggleSwitch(name) {
      let data = cloneDeep(this.cookieTypes)
      if (this.$_cookieSelectMixin_isChecked(name)) {
        data = this.cookieTypes.filter((item) => item !== name)
      } else if (['fnc','web', 'sts', 'adv'].includes(name)) {
        data.push(name)
      }
      this.$store.commit('main/setTempCookies', data)
    },
    $_cookieSelectMixin_confirmSelection(data) {
      this.$_cookieSelectMixin_toggleSwitch('')
      this.$_cookieSelectMixin_sendTrackingData(data)
      this.$_cookieSelectMixin_closeCookieAlert()
    },
    $_cookieSelectMixin_selectAll(data) {
      this.$store.commit('main/setTempCookies', ['fnc','web', 'sts', 'adv'])

      this.$_cookieSelectMixin_confirmSelection(data)
    },
    $_cookieSelectMixin_selectOnlyFunc(data) {
      this.$store.commit('main/setTempCookies', ['fnc'])

      this.$_cookieSelectMixin_confirmSelection(data)
    },
    $_cookieSelectMixin_closeCookieAlert() {
      let data = cloneDeep(this.cookieTypes)
      if (!data.includes('fnc')) {
        data.push('fnc')
      }

      this.$store.dispatch('main/setGdprCookie', data)
      this.$cookieSelectMixin_removeUnselectedCookies()
      this.$store.commit('main/setHideCookieAlert', true)
      ScrollUtils.enableScroll()
    },
    $cookieSelectMixin_removeUnselectedCookies() {
      new Pimcore().get('/get-cookie-list/')
        .then((response) => {
          const cookies = ['web', 'sts', 'adv']
            cookies.forEach(name => {
            if (!this.$_cookieSelectMixin_isChecked(name)) {
              this.$_cookieSelectMixin_removeCookiesFromCategory(response.data[name])
            }
          })
        })
        .catch(e => {
          Sentry.captureException(e)
        })
    },
    $_cookieSelectMixin_removeCookiesFromCategory(cookieList) {
      cookieList.forEach((cookie) => {
        const cookieName = cookie.replace('#', '')
        const name = CookieUtils.findCookieByName(cookieName)

        if (name !== '') {
          CookieUtils.setCookie(name, '', -1)
        } else {
          CookieUtils.setCookie(cookieName, '', -1)
        }
      })
    },
    $_cookieSelectMixin_sendTrackingData(data) {
      let label = 'Select: none'
      let action = data

      if (
        this.$_cookieSelectMixin_isChecked('sts') &&
        this.$_cookieSelectMixin_isChecked('web') &&
        this.$_cookieSelectMixin_isChecked('adv')
      ) {
        label = 'Select: all'
      } else {
        label = `Select: custom;`
        label += `Statistics: ${this.$_cookieSelectMixin_isChecked('sts')};`
        label += `Advertising: ${this.$_cookieSelectMixin_isChecked('adv')};`
        label += `Personalised Website: ${this.$_cookieSelectMixin_isChecked('web')};`
        label += `Functional: ${this.$_cookieSelectMixin_isChecked('fnc')};`
      }

      this.$_cookieSelectMixin_sendData(action, label)
    },
    $_cookieSelectMixin_sendData(eventAction, eventLabel) {
      const data = {
        event: 'GAevent',
        eventCategory: 'All pages',
        eventAction,
        eventLabel,
        eventValue: 0,
        nonInteraction: false
      }
      DataLayer.doPush(data)
    },
    $_cookieSelectMixin_showMore() {
      this.showCheckboxes = true
    }
  }
}

export default CookieSelectMixin
